import { useSelect } from '~/store'
import { selDocumentViewerState } from '.'
import type { DocumentViewerState } from '.'

/**
 * Owns the reactive state projection used by document-viewer extensions.
 *
 * This is the app-layer composition root for document-viewer state. Viewer
 * hosts remain ignorant of the feature extensions installed behind it.
 */
export function useDocumentViewerState(): DocumentViewerState {
  return useSelect('stFolder', selDocumentViewerState)
}
